// import './i18n'; // 🔁 Must be FIRST to initialize translations

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import { RouterProvider } from 'react-router-dom';
// import { Provider } from 'react-redux';
// import { store } from './store';

// import { router } from './router';

// import 'antd/dist/reset.css';

// import './styles/index.css';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <RouterProvider router={router} />
//     </Provider>
//   </React.StrictMode>,
// );
import './i18n'; // 🔁 Must be first to initialize translations

import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { QueryClientProvider } from '@tanstack/react-query';

import i18n from './i18n'; // import your configured i18n instance
import { store } from './store';
import { router } from './router';
import { queryClient, cacheUtils } from './store/queryClient';

import 'antd/dist/reset.css';
import './styles/index.css';

// Development ortamında cache devre dışı
const isDevelopment = process.env.NODE_ENV === 'development';

// Uygulama başlangıcında cache'i yükle (sadece production'da)
if (!isDevelopment) {
  cacheUtils.loadPersistedCache();
}

// Sayfa kapatılırken cache'i kaydet (sadece production'da)
if (!isDevelopment) {
  window.addEventListener('beforeunload', () => {
    cacheUtils.persistCache();
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <RouterProvider router={router} />
        </I18nextProvider>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);
